<template>
  <div
    class="specification-content"
    :class="{ active: selectedIndex == index }"
    @click="$emit('selectedValue', index)">
    <div class="specification-icon">
      <i class="icon icon-drag-handle"></i>
    </div>
    <div class="specification-name">
      <TextComponent fieldName="Name" v-model="specification.name" />
    </div>
    <div class="specification-value">
      <TextareaComponent
        @onChangeValue="setSpecificationValue"
        label="Value"
        v-model="specificationValue" />
    </div>
  </div>
</template>

<script>
import TextComponent from '../base.component/TextComponent.vue';
import TextareaComponent from '../base.component/TextareaComponent.vue';

export default {
  components: {
    TextComponent,
    TextareaComponent,
  },

  data() {
    return {
      specificationValue: '',
    };
  },

  props: {
    specification: {
      type: Object,
      default: {
        name: '',
        value: '',
        arrayValue: [],
      },
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      required: true,
    },
    selectedIndex: {
      type: Number,
      default: -1,
    },
  },

  watch: {
    'specification.name': function () {
      this.initSpecificationValue();
    },
  },

  created() {
    this.initSpecificationValue();
  },

  methods: {
    initSpecificationValue() {
      if (this.specification.value && this.specification.value != '') {
        this.specificationValue = this.specification.value;
      } else {
        this.specificationValue = this.specification.arrayValue.join('\n');
      }
    },

    setSpecificationValue() {
      const arrayValue = this.specificationValue.split('\n');

      if (arrayValue.length === 1) {
        this.specification.value = this.specificationValue;
      } else {
        this.specification.arrayValue = arrayValue;
      }
    },
  },
};
</script>

<style scoped lang="less">
@import '~@eds/vanilla/variables/dark.less';

.specification-content {
  display: flex;
  border: solid 1px @gray-46;
  padding: 1rem;
}

.active {
  border-color: @blue-43;
}

.specification-name,
.specification-value,
.specification-icon {
  padding: 0.5rem;
}

.specification-name,
.specification-value {
  width: -webkit-fill-available;
}
</style>